import * as React from 'react';
import Tooltip from 'antd/lib/tooltip';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import { slugify } from '@/helpers';

interface RequestFormFieldNameProps {
    name: string;
}

const RequestFormFieldName: React.FC<RequestFormFieldNameProps> = ({ name }) => (
    <Tooltip
        title={
            <Space size={4}>
                <Text style={{ color: 'inherit' }}>Field ID:</Text>
                <Text code style={{ color: 'inherit' }}>
                    {slugify(name)}
                </Text>
            </Space>
        }
    >
        <Text
            style={{
                textDecorationLine: 'underline',
                textDecorationStyle: 'dotted',
                textUnderlineOffset: 3,
            }}
        >
            {name}
        </Text>
    </Tooltip>
);

export default RequestFormFieldName;
